import { Box, LinearProgress } from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { NoData, generateColumn } from '../DataGrid/utils';
import NoDataTableIcon from '../../../Icons/empty_table_placeholder.svg';

const ReportDataGrid = ({
    rows,
    columns,
    loading = false,
    height = 600,
    noRowsLabel = 'No data found. Try adjusting your filters.',
    density,
    initialState,
    ...rest
}) => {
    const processedColumns = columns.map(col => generateColumn({ flex: 1, ...col }));

    return (
        <Box>
            {loading && <LinearProgress sx={{ mb: 1 }} />}
            <Box sx={{ height }}>
                <DataGridPro
                    rows={rows}
                    columns={processedColumns}
                    disableRowSelectionOnClick
                    hideFooter
                    density={density}
                    initialState={initialState}
                    sx={{
                        '& .MuiDataGrid-row:nth-of-type(even)': {
                            backgroundColor: '#fafafa',
                        },
                    }}
                    slots={{
                        noRowsOverlay: () => (
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                                <NoData
                                    noTableDataIcon={NoDataTableIcon}
                                    noResultText={noRowsLabel}
                                />
                            </Box>
                        ),
                    }}
                    {...rest}
                />
            </Box>
        </Box>
    );
};

export default ReportDataGrid;
